import {
  ExploreAggColumnType,
  exploreAggColumnTypeToLabel,
} from "@/v2/entities/explore/columns/ExploreColum.model";
import { ColumnSearchInput } from "./ColumnSearchInput";
import { useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";

interface AggregationColumnsSectionProps {
  availableColumns: ExploreAggColumnType[];
  selectedColumns: ExploreAggColumnType[];
  onColumnToggle: (column: ExploreAggColumnType) => void;
}

export function AggregationColumnsSection({
  availableColumns,
  selectedColumns,
  onColumnToggle,
}: AggregationColumnsSectionProps) {
  const [searchAggColumns, setSearchAggColumns] = useState("");

  const filteredColumns = availableColumns.filter((aggColumn) => {
    if (searchAggColumns.length > 0) {
      const label = exploreAggColumnTypeToLabel[aggColumn] || aggColumn;
      return label.toLowerCase().includes(searchAggColumns.toLowerCase());
    }
    return true;
  });

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm text-gray-500">Aggregation properties</label>

      <ScrollArea className="max-h-[200px] text-sm overflow-y-auto">
        <div className="flex flex-col gap-1">
          {filteredColumns.map((aggColumn) => (
            <Button
              key={aggColumn}
              variant="ghost"
              size="sm"
              className="flex justify-start gap-2 px-2 py-1"
              onClick={() => onColumnToggle(aggColumn)}
            >
              <Checkbox
                checked={selectedColumns.includes(aggColumn)}
                onCheckedChange={() => onColumnToggle(aggColumn)}
              />

              {exploreAggColumnTypeToLabel[aggColumn] || aggColumn}
            </Button>
          ))}
        </div>
      </ScrollArea>
      <div className="py-1">
        <ColumnSearchInput
          value={searchAggColumns}
          onChange={setSearchAggColumns}
        />
      </div>
    </div>
  );
}
